const filters = [
  {
    name: 'FormatTime',
    execute: value => {
      if (value != null) {
        let hours = Math.floor(value / 3600);
        value %= 3600;
        let minutes = Math.floor(value / 60);
        let seconds = value % 60;
        let addZero = v => (v < 10 ? '0' + v : v);
        let t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        while (+t[0] === 0 && t.length > 1) {
          t.shift();
        }
        return t.length === 1 ? t[0] + 's' : t.join(':');
      }
    },
  },
];

export default filters;



// WEBPACK FOOTER //
// ./src/filters/index.js